import * as React from "react";

import { RobotoIconButton, RobotoTooltip } from "@/shared/components";
import { FileRecord } from "@/shared/domain/files";
import { downloadFile } from "@/shared/domain/files/filesystem";
import { DownloadIcon } from "@/shared/foundation/icons/mui";
import { ErrorMonitoringService } from "@/shared/services/ErrorMonitoringService";

import { useGetFileContents } from "../hooks";

interface DownloadFileButtonProps {
  fileRecord: FileRecord;
}

export function DownloadFileButton({ fileRecord }: DownloadFileButtonProps) {
  const getFileContentsAsUrl = useGetFileContents();

  const [error, setError] = React.useState<string | null>(null);

  const download = () => {
    getFileContentsAsUrl(fileRecord, {
      forDownload: true,
    })
      .then((signedUrl: URL) => {
        downloadFile(fileRecord.relative_path, signedUrl.toString());
        setError(null);
      })
      .catch((error: unknown) => {
        ErrorMonitoringService.captureError(error);
        setError("Failed to download. Try again.");
      });
  };

  return (
    <RobotoTooltip title={error || "Download file"}>
      <span>
        <RobotoIconButton
          eventName="FileDownloaded"
          eventProperties={{ fileId: fileRecord.file_id }}
          onClick={download}
          sx={{ padding: "0.5rem" }}
          size="small"
        >
          <DownloadIcon
            style={{
              width: "1.25rem",
              height: "1.25rem",
            }}
          />
        </RobotoIconButton>
      </span>
    </RobotoTooltip>
  );
}
